import React from 'react';

export default {
  pt: {
    pageTitle: 'Homing - Proprietários',
    pageDescription: 'Rentabilize a sua casa sem preocupações',

    email: 'proprietarios@homing.com.pt',
    formTitle1: 'Rentabilize a sua casa ',
    formTitle2: 'sem preocupações',
    formText1: 'Cuidamos de tudo por si, fale-nos da sua propriedade.',
    formHouseType: 'Tipologia',
    formAddress: 'Freguesia',
    formEmail: 'Email',
    formPhoneNumber: 'Contacto telefónico',
    formSubmit: 'Enviar',
    formSuccessText1: 'Obrigado pela sua confiança,',
    formSuccessText2: 'entraremos em contacto brevemente',

    reasonsTitle1: 'Razões para deixar ',
    reasonsTitle2: 'a sua casa connosco',
    reasonsText:
      'Resultado da nossa aposta numa estratégia de preço transparente e flexível, tornámo-nos num dos maiores, e bem sucedidos, gestores de propriedades para Alojamento Local. Hoje, contamos com a confiança de mais de 100 proprietários e ambicionamos tornarmo-nos líderes de mercado em Portugal. Distinguimo-nos pela nossa presença no Largo do Rato, com uma loja 24/7, oferecendo aos nossos hóspedes uma sensação de confiança, desde o momento da reserva até ao check-out.',
    reason1Title: 'Liberdade contratual',
    reason1Text:
      'O período dos contratos pode ser acordado caso a caso e os proprietários podem usufruir dos seus apartamentos se necessitarem. Por exemplo, para férias ou viagens de negócios.',
    reason2Title: 'Maior rendimento',
    reason2Text:
      'Modelo de gestão otimizado para rentabilizar ao máximo as suas propriedades. Obtemos o maior rendimento para os proprietários, libertando-os de qualquer trabalho ou preocupações.',
    reason3Title: 'Manutenção rigorosa',
    reason3Text:
      'A Homing só aluga apartamentos em perfeitas condições. Para isso, os nossos técnicos de manutenção vistoriam regularmente os apartamentos que gerimos de forma a estarem sempre impecáveis.',
    reason4Title: 'Zero preocupações',
    reason4Text:
      'Tratamos de todos os procedimentos legais (registo na câmara, participação ao SEF, etc...), check-in, check-out, limpeza e tratamento de roupas. Os proprietários podem até estar fora de Portugal bastando acompanhar as reservas dos seus apartamentos online.',

    innovationTitle1: 'Inovação, Tecnologia',
    innovationTitle2: 'e Responsabilidade Social',
    innovation1Text: (
      <span>
        Os nossos apartamentos contam com um sistema de self-check-in Inovador e Seguro,
        proporcionando uma experiência fácil e simples. <br /> Os hóspedes agradecem por não terem
        de andar com chaves. <br />Os proprietários ficam descansados de não haver risco de estas se
        perderem.
      </span>
    ),
    innovation2Text: (
      <span>
        Para termos sucesso na nossa missão, e garantir que quem nos visita se sente em casa,
        disponibilizamos aos nossos hóspedes um smart phone com acesso a internet, chamadas, as
        melhores app’s e dicas da cidade. <br /> Inclui ainda a nossa app, apenas disponível nos
        nossos smart phones, onde podem pedir pequeno-almoço em casa, reservar os restaurantes mais
        trendy, comprar tours e experiências.
      </span>
    ),
    innovation3Text:
      'Preocupamo-nos com as pessoas desfavorecidas, por isso, recentemente desenvolvemos um programa social com o objetivo de ajudar aqueles que vivem fora de Lisboa e não podem pagar um alojamento quando visitam o seu médico.',

    servicesTitle: 'Os nossos Serviços',
    servicesText1: '',
    servicesText2: (
      <span>
        Comissão<br /> de gestão
      </span>
    ),
    servicesText3: 'ou',
    servicesText4: (
      <span>
        Rendimento<br /> garantido
      </span>
    ),

    serviceListItem1: 'Gestão de reservas',
    serviceListItem2: 'Presença em mais de 20 plataformas',
    serviceListItem3: 'Comercialização e gestão',
    serviceListItem4: 'Preços variáveis por épocas',
    serviceListItem5: 'Análise de mercado',
    serviceListItem6: 'Consultoria em design de interiores',
    serviceListItem7: 'Gestor de conta dedicado',
    serviceListItem8: 'Check-in e check-out',
    serviceListItem9: 'Apoio ao hóspede',
    serviceListItem10: 'Limpeza e manutenção',
    serviceListItem11: 'Esclarecimento fiscal e legal',
    serviceListItem12: 'Comunicação ao SEF',

    newServicesText: 'Novos serviços brevemente',

    locationAddressTitle: 'Morada',
    locationAddressText1: 'Largo do Rato,7 A/B',
    locationAddressText2: '1250-186 Lisboa',
    locationContactsTitle: 'Contactos',

    imageBarTitle: 'Otimize o seu rendimento',
    imageBarButton: 'Comece aqui',

    footerText1: 'Copyright © 2018 Homing. All rights reserved',
    footerText2: 'Powered by',
  },
  en: {
    pageTitle: 'Homing - Owners',
    pageDescription: 'Monetize your property',

    email: 'owners@homing.com.pt',
    formTitle1: 'Monetize your property',
    formTitle2: '',
    formText1: 'We take care of everything, tell us about your apartment.',
    formHouseType: 'Number of bedrooms',
    formAddress: 'Parish',
    formEmail: 'Email',
    formPhoneNumber: 'Mobile number',
    formSubmit: 'Submit',
    formSuccessText1: 'Thanks for your confidence,',
    formSuccessText2: 'we will be in touch soon.',

    reasonsTitle1: 'Why should you ',
    reasonsTitle2: 'trust us with your property?',

    reasonsText:
      'As a result of our commitment to a transparent and flexible pricing strategy, we have become one of the largest, and most successful, Vacation Rentals managers. Today, we rely on the trust of more than 100 owners and we aim to become market leaders in Portugal. We distinguish ourselves by our presence in Largo do Rato, with a 24/7 store, offering our guests a feeling of confidence, from the moment of the reservation until the check-out.',
    reason1Title: 'Freedom of contract',
    reason1Text:
      'The contract period may be agreed on a case-by-case basis. Owners can use their apartments if necessary. For example, holidays or business trips.',
    reason2Title: 'Higher income',
    reason2Text:
      'Optimized management model to maximize your properties. Transparent and Flexible Price. We compensate the management fee with an increase in the profitability, visibility and operation of your apartment. We provide our clients with a profile on our platform, in order to guarantee total transparency and monitoring the income on their properties.',
    reason3Title: 'Rigorous maintenance',
    reason3Text:
      'Homing only rents apartments in perfect conditions. Our maintenance technicians regularly inspect the apartments to guarantee they are always spotless.',
    reason4Title: 'Zero concerns',
    reason4Text:
      'We deal with all Legal & Operational procedures inherent to the activity (registration in the City Hall, report to SEF, check-in, check-out, cleaning, Laundry, etc...). Dedicated account manager whenever you need any clarification.',

    innovationTitle1: <span>Innovation, Technology</span>,
    innovationTitle2: (
      <span>
        <span style={{ fontFamily: 'sans-serif' }}>&</span> Social responsibility
      </span>
    ),
    innovation1Text: (
      <span>
        Our appartements have an innovative and safe self-check-in system, providing an easy and
        simple experience.<br /> Guests are pleased for not having to deal with keys and old locks.{' '}
        <br /> Owners don’t have to worry about forgotten keys.
      </span>
    ),
    innovation2Text: (
      <span>
        To be successful in our mission, and to ensure that those who visit us feel at home, we
        provide smart phones for our guests with internet access, calls, the best apps and tips of
        the city. <br /> It also includes our app, only available on our smart phones, where you can
        order breakfast at home, book the trendiest restaurants, buy tours and experiences.
      </span>
    ),
    innovation3Text:
      'Homing cares about the underprivileged people, therefore, we recently developed a social program to help those who live out of Lisbon and cannot afford to pay an accommodation when visiting their doctor for healthcare purposes.',

    servicesTitle: 'Our services',
    servicesText1: '',
    servicesText2: (
      <span>
        Management<br /> fee
      </span>
    ),
    servicesText3: 'or',
    servicesText4: (
      <span>
        Fixed<br /> income
      </span>
    ),

    serviceListItem1: 'Reservation management',
    serviceListItem2: 'Presence in more than 20 platforms',
    serviceListItem3: 'Concierge service',
    serviceListItem4: 'Prices adjusted to each season',
    serviceListItem5: 'Market analysis',
    serviceListItem6: 'Interior design consultants',
    serviceListItem7: 'Dedicated account manager',
    serviceListItem8: 'Check-in and check-out',
    serviceListItem9: 'Guest support',
    serviceListItem10: 'Cleaning and maintenance',
    serviceListItem11: 'Tax and legal advice',
    serviceListItem12: 'Communication to the SEF',

    newServicesText: 'New services soon',

    locationAddressTitle: 'Address',
    locationAddressText1: 'Largo do Rato,7 A/B',
    locationAddressText2: '1250-186 Lisboa',
    locationContactsTitle: 'Contacts',

    imageBarTitle: 'Optimize your income',
    imageBarButton: 'Start now',

    footerText1: 'Copyright © 2018 Homing. All rights reserved',
    footerText2: 'Powered by',
  },
};



// WEBPACK FOOTER //
// ./src/translations.js